// @scripts
import { ISite } from '../utils/types';
import { config } from '../core/config';
import BaseService from './base-service';

class LocationService extends BaseService {
  async getSites(): Promise<ISite[]> {
    return this.get('sites');
  }

  async getSiteDetail(siteId: number): Promise<ISite> {
    return this.get(['siteDetails', siteId]);
  }
}

export default new LocationService(config.services.locations);
